import {
  normalizeMassFilterValues,
  type MassFilterNormalizeOptions,
} from '@outkeep/shared';

/**
 * Разделители значений в массовом вводе: перевод строки и табуляция приходят
 * при вставке столбца из таблицы, запятая и точка с запятой — при вставке
 * перечисления из письма или мессенджера. Пробел разделителем не считается:
 * номер договора может содержать пробелы («Демо договор пакета»), и такие
 * значения иначе распадались бы на части и никогда не находились бы.
 */
const MASS_FILTER_VALUE_SEPARATORS = /[\r\n\t,;]+/;

/**
 * Разбирает введённый или вставленный текст на набор значений фильтра и
 * нормализует его той же функцией, что и сервер.
 */
export function parseMassFilterInput(
  input: string,
  options: MassFilterNormalizeOptions = {},
): string[] {
  if (!input) {
    return [];
  }

  return normalizeMassFilterValues(
    input.split(MASS_FILTER_VALUE_SEPARATORS),
    options,
  );
}

/** Собирает набор значений обратно в текст для поля ввода. */
export function formatMassFilterInput(values: readonly string[]): string {
  return values.join('\n');
}

/** Приводит значение фильтра из rqQuery к набору значений. */
export function toMassFilterValues(
  value: string | string[] | undefined | null,
): string[] {
  if (!value) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}

/**
 * Готовит набор к отправке: одиночное значение остаётся строкой — так
 * фильтр совместим со старыми ссылками и читаемо выглядит в адресе.
 */
export function toMassFilterQueryValue(
  values: readonly string[],
): string | string[] | null {
  if (!values.length) {
    return null;
  }

  return values.length === 1 ? values[0] : [...values];
}
